const isInCCLiframe =
  'ccl' ===
  new URLSearchParams((window as any).location.search).get('platform');

export default isInCCLiframe;
